export default __webpack_public_path__ + "static/media/letterjumble_locked.032eef51.svg";